import { create } from "zustand";

interface ConfirmOptions {
  title?: string;
  text?: string;
  function: () => any;
}

interface ConfirmStore {
  confirm?: ConfirmOptions;
  openConfirmDialog: (options: ConfirmOptions) => void;
  closeConfirmDialog: () => void;
}

export const useConfirmStore = create<ConfirmStore>((set) => ({
  openConfirmDialog: (options: ConfirmOptions) =>
    set((state) => ({ confirm: options })),
  closeConfirmDialog: () => set({ confirm: undefined }),
}));
